module.exports = __webpack_public_path__ + "static/media/tabs-img.36813daf.svg";